import $ from 'domtastic'




/* SELECT
----------------------------------------------------------------------------------------------------*/

export default class Select {

    constructor($el) {
        this.$els = {
            el : $($el),
            row: $($el.closest('.formRow')),
        }

        this.changeHandler = ({ target }) => { this.onChange(target) }

        this.onChange(this.$els.el[0])
        this.bindEvents()
    }


    bindEvents() {
        this.$els.el.on('change', this.changeHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onChange({ value }) {
        this.$els.row.toggleClass('is-filled', value !== '')
    }




    /* Actions
    --------------------------------------------------------- */




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



